export default {
  _cache: {},
  setItem(key, data) {
    if (key && data) {
      this._cache[key] = data
    } else {
      throw new Error('must has key and data')
    }
  },
  getItem(key) {
    return this._cache[key]
  },
  removeItem(key) {
    if (this._cache[key]) {
      delete this._cache[key]
    }
  },
  clear() {
    // eslint-disable-next-line no-return-assign
    return (this._cache = {})
  },
  keys(fn) {
    if (typeof fn === 'function') {
      let index = 0
      for (let key in this._cache) {
        fn(this._cache[key], key, index)
        index++
      }
    }
  },
  ifExistCache(id) {
    //根据id判断是否存在缓存
    for (let key in this._cache) {
      if (key == id) {
        return true
      }
    }
    return false
  },
  ifIdChildren(routeId, arr) {
    let temp = routeId
    if (routeId.indexOf('[') > -1) {
      temp = routeId.split('[')[0]
    }
    let tempArr = []
    for (let key in this._cache) {
      if (key.indexOf(temp) > -1) {
        tempArr.push(key)
      }
    }
    if (arr.length == tempArr.length) {
      return true
    } else {
      return false
    }
  },
  getCacheMemory() {
    return this._cache
  },
}
